
import { i18nText } from '@/locales';

    import { RouterProperties } from "@/router/routerProperties";
    import { appFiltersStore } from "@/store/modules/appFilters";
    import { ServicesCategoryStore } from "@/store/modules/ServicesCategory";
    import { AppFilters } from "@/UI/components/extFilter/AppFilters";
    import { serviceswithQuillwortMix } from "@/UI/mixins/Store/serviceswithQuillwortMix";
    import { StoreMix } from "@/UI/mixins/Store/StoreMix";
    import { Component, Watch } from "vue-property-decorator";
    import PageTitle from "@/UI/components/common/PageTitle.vue";
    import AppSimpleLink from "@/UI/components/Link/AppSimpleLink.vue";
    import { mixins } from "vue-class-component";
    import { RouterNameEnum } from "@/router/router.types";
    import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
    import moment from "moment";
    import { Button, Menu, List, Table, Select, Tooltip, Icon } from "ant-design-vue";
    import { OperationsTableMix } from "@/UI/mixins/Store/OperationsTableMix";
    import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
    import { OperationsMix } from "@/UI/mixins/Store/OperationsMix";
    import { FiltersData } from "@/entity/filters/extFilter";
    import { limitStrLength } from "@/UI/lib/support";
    import i18n from "@/locales";
    import { getStudioId } from "@/UI/lib/state";
    import { OriginEntity, ProductsEntity } from "@/entity/warehouse/Operations/Operations.types";
    import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue";
    import { ProxyGetData } from "@/UI/components/Helpers/getData";
    import { appPaginationStore } from "@/store/modules/appPagination";
    import { NewProxyDataForm } from "@/UI/components/Helpers/NewProxyDataForm";

    import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"
    @Component({
        components: {
            "a-button": Button,
            "a-menu-item": Menu.Item,
            "a-list-item": List.Item,
            "a-list-item-meta": List.Item.Meta,
            "a-select": Select,
            "a-select-option": Select.Option,
            "a-table": Table,
            "a-icon": Icon,
            "a-tooltip": Tooltip,
            PageTitle,
            BaseDataForm,
            AppSimpleLink,
            SortComponent,
            FilterTableComponent
        },
        methods: { moment, limitStrLength },
    })
    export default class Operations extends mixins(
        ProxyGetData,
        OperationsTableMix,
        OperationsMix,
        serviceswithQuillwortMix,
        StoreMix,
    ) {
        RouterNames = RouterNameEnum;
        filtersData = new FiltersData();
        searchTimer: number = 0;
        //Studio_id = this.$store.state['salon_id']
        //TODO::Обновляем значения фильтров в завитмимости от salon_id

        async getStoresData(): Promise<void> {
            await this.fetchModule([
                { s: "services", p: { filter: { salon_id: getStudioId(this) } } },
                // {s: 'servicesCategory', p: {filter: {salon_id: getStudioId(this)}}},
                { s: "warehouse", p: { filter: { salon_id: getStudioId(this) } } },
            ]);
            await ServicesCategoryStore.fetchAll({ filter: { salon_id: getStudioId(this) } });
        }

        @Watch("$store.state.salon_id", { immediate: false })
        async onStudioChange(): Promise<void> {
            await this.getStoresData();
        }

        calcOrigin(products: ProductsEntity[]): any {
            let sum = 0;
            let count = 0;
            if (products) {
                products.forEach((product: ProductsEntity) => {
                    if (product) {
                        count += Number(product["quantity"] as number);
                    }
                    if (product !== undefined && product["origin"] !== undefined) {
                        if (product["origin"] !== null) {
                            let dTa = product["origin"] as unknown as OriginEntity;
                            sum = sum + Number(dTa["quantity"] as number);
                        }
                    }
                });
            }
            return { sum, count };
        }

        visitLink(record: Record<string, any>): Record<string, any> {
            return {
                name: this.RouterNames.VisitsNewStatus,
                params: {
                    Studio: getStudioId(this),
                    id: record.visit.id,
                    Worker: record.visit.cosmetologists_id,
                    mode: "status",
                    params: JSON.stringify({ id: record.visit.id, visitData: record.visit }),
                    //event: JSON.stringify(record.visit),
                    //isNew: "0",
                },
            };
        }

        operationLink(record: Record<string, any>): any {
            if (record["payment_status_id"] === 1) {
                return {
                    name: this.RouterNames.StoreOperationsReport,
                    params: {
                        Studio: getStudioId(this),
                        Data: JSON.stringify(record.id),
                        mode: "1",
                        name: i18nText("Операция") + " " + record.type.name,
                        // Data: JSON.stringify({products: record['products']})
                    },
                };
            } else {
                if (record["storage_operation_type_id"] === 1) {
                    return {
                        name: RouterNameEnum.StoreOperationsSale,
                        params: {
                            Studio: getStudioId(this),
                            id: record["id"],
                        },
                    };
                }
                if (record["storage_operation_type_id"] === 2) {
                    return {
                        name: RouterNameEnum.StoreOperationsArrival,
                        params: {
                            Studio: getStudioId(this),
                            id: record["id"],
                        },
                    };
                }
                if (record["storage_operation_type_id"] === 3) {
                    return {
                        name: RouterNameEnum.StoreOperationsWriteOff,
                        params: {
                            Studio: getStudioId(this),
                            id: record["id"],
                        },
                    };
                }
            }
        }

        moveLink(): any {
            return {
                name: this.RouterNames.StoreOperationsMove,
                params: { Studio: getStudioId(this), id: "0" },
            };
        }

        saleLink(): any {
            return {
                name: this.RouterNames.StoreOperationsSale,
                params: { Studio: getStudioId(this), id: "0" },
            };
        }

        arrivalLink(): any {
            return {
                name: this.RouterNames.StoreOperationsArrival,
                params: { Studio: getStudioId(this), id: "0" },
            };
        }

        writeOffLink() {
            return {
                name: this.RouterNames.StoreOperationsWriteOff,
                params: { Studio: getStudioId(this), id: "0" },
            };
        }

        messages = i18n.t("stores.operations.sale");

        async created(): Promise<void> {
            if (!this.formReady) {
                try {
                    this.proxyFilter = {
                        salon_id: getStudioId(this)
                    };
                    appPaginationStore.setCurrent(1);
                    await this.sortedData("desc", { dataIndex: "created_at" });
                    await this.fetchModules([{ s: "category", p: { limit: -1 } }]);
                    await this.getStoresData();
                    this.setFilters(this);
                } catch (e) {
                    console.log(e);
                } finally {
                    this.formReady = true;
                }
            }
        }

        setFilters(that: any): void {
            this.filtersData.filters.push(
                {
                    key: 0,
                    type: "datetimerange",
                    label: i18nText("Период"),
                    defaultValue: 0,
                    filtered: false,
                    fieldNames: ["partner_id"],
                    async onChange(value: any) {
                        console.log(value)
                        let filter = {}
                        if (value.length) {
                            filter = {
                                date_from: value[0].format("DD.MM.YYYY"),
                                date_to: value[1].format("DD.MM.YYYY")
                            }
                        } else {
                            filter = {
                                date_from: '0',
                                date_to: '0'
                            }
                        }
                        await that.filterData(filter)
                    },
                    async ok(value: any) {
                        let filter = {}
                        if (value.length) {
                            filter = {
                                date_from: value[0].format("DD.MM.YYYY"),
                                date_to: value[1].format("DD.MM.YYYY")
                            }
                        } else {
                            filter = {
                                date_from: '0',
                                date_to: '0'
                            }
                        }
                        await that.filterData(filter)
                    },
                },
                {
                    key: 1,
                    type: "select",
                    label: i18nText("Типы операций"),
                    defaultValue: 0,
                    default_value: [i18nText("Не указано")],
                    placeholder: "",
                    value: [
                        {
                            label: i18nText("Не указано"),
                            key: "0",
                        },
                        {
                            label: i18nText("Продажа"),
                            key: "1",
                        },
                        {
                            label: i18nText("Приход"),
                            key: "2",
                        },
                        {
                            label: i18nText("Списание"),
                            key: "3",
                        },
                    ],
                    fieldNames: ["active"],
                    filtered: false,
                    async onChange(value: any) {
                        let filter = {}

                        if (Number(value)) {
                            filter = {
                                storage_operation_type_id: value
                            }
                        } else {
                            filter = { storage_operation_type_id: "0" }
                        }
                        console.log("FILTER", filter)
                        await that.filterData(filter)
                    },
                },
                {
                    key: 2,
                    type: "sourceVuex",
                    label: i18nText("Склады"),
                    defaultValue: 0,
                    default_value: [i18nText("Не указано")],
                    value: [],
                    source: this.stores?.data,
                    fieldNames: ["city_id"],
                    vuexSource: "warehouse",
                    storeVuexSource: "warehouse",

                    filtered: false,
                    async onChange(value: any) {
                        let filter = { store_id: value }
                        await that.filterData(filter)
                        /*await that.setRouteFilterTable(
                        RouterProperties.operations, {store_id: value,}, true);*/
                        /*await appFiltersStore.setFiltersSource({
                      source: RouterProperties.operations,
                      data: data,
                    });*/
                        // await appFiltersStore.setfilterSalons({ city_id: value })
                    },
                },
                {
                    key: 3,
                    type: "source",
                    label: i18nText("Услуга с расходником"),
                    defaultValue: 0,
                    default_value: [i18nText("Не указано")],
                    value: [],
                    source: this.serviceswithQuillwort?.data,
                    fieldNames: ["city_id"],
                    storeSource: AppFilters.operations,
                    filtered: false,
                    async onChange(value: any) {
                        await that.filterData({ storage_operation_type_id: value })
                    },
                },

                {
                    key: 4,
                    type: "select",
                    label: i18nText("Статус оплаты"),
                    defaultValue: 0,
                    default_value: [i18nText("Не указано")],
                    value: [
                        {
                            label: i18nText("Не указано"),
                            key: "0",
                        },
                        {
                            label: i18nText("Оплачен полностью"),
                            key: "1",
                        },
                        {
                            label: i18nText("Оплачен частично"),
                            key: "2",
                        },
                        {
                            label: i18nText("Не оплачен"),
                            key: "3",
                        },
                    ],
                    fieldNames: ["active"],
                    filtered: false,
                    async onChange(value: any) {
                        let filter = {payment_status: value}
                        await that.filterData(filter)
                    },
                },
                {
                    key: 5,
                    type: "input",
                    label: i18nText("Поиск товара по наименованию или коду"),
                    defaultValue: 0,
                    placeholder: i18nText("Не указано"),
                    filtered: false,
                    fieldNames: ["partner_id"],
                    async onChange(value: any) {
                        clearTimeout(that.searchTimer);
                        that.searchTimer = setTimeout(async () => {
                            let filter = { product: value.target.value }

                            await that.filterData(filter)
                        }, 500);
                    },
                },
                {
                    key: 6,
                    type: "input",
                    label: i18nText("Поиск клиента по имени или телефону"),
                    defaultValue: 0,
                    placeholder: i18nText("Не указано"),
                    filtered: false,
                    fieldNames: ["partner_id"],
                    async onChange(value: any) {
                        clearTimeout(that.searchTimer);
                        that.searchTimer = setTimeout(async () => {
                            let data: Record<any, any> = {
                                salon_id: getStudioId(that),
                            };
                            let filter = { client: value.target.value }

                            await that.filterData(filter)
                        }, 500);
                    },
                },
                {
                    key: 7,
                    type: "input",
                    label: i18nText("Поиск по номеру документа"),
                    defaultValue: 0,
                    placeholder: i18nText("Не указано"),
                    filtered: false,
                    fieldNames: ["partner_id"],
                    async onChange(value: any) {
                        await that.filterData({
                            document: value.target.value
                        })
                    },
                },
                {
                    key: 8,
                    type: "input",
                    label: i18nText("Услуга с расходником"),
                    defaultValue: 0,
                    placeholder: i18nText("Не указано"),
                    filtered: false,
                    fieldNames: ["with_product"],
                    async onChange(value: any) {
                        await that.filterData({
                            with_product: value.target.value
                        })
                    },
                },
            );
            this.filter_load = true;
        }

        async setFilter({ by, sort }: { by: string; sort: any }): Promise<void> {
            await this.filterData(appFiltersStore.filter);
            await this.sortedData(by, { dataIndex: sort.dataIndex });
        }

        async clearFilter(clear: string): Promise<void> {
            await this.sortedData("desc", { dataIndex: "created_at" });
        }

        async clearAFilter(): Promise<void> {
            console.log("clearAFilter");
            this.proxyFilter = {
                salon_id: getStudioId(this),
            };
            for (let i of this.filtersData.filters) {
                i.default_value = [i18nText("Не указано")];
            }
            await this.sortedData("desc", { dataIndex: "created_at" });
        }
    }
